import styled, { keyframes } from "styled-components";

const bounce = keyframes`
	0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
	40% {transform: translateY(-30px);}
	60% {transform: translateY(-15px);}
`

export const Container = styled.div`
  align-items: center;
  background: rgb(0,166,135);
  background: linear-gradient(135deg, rgba(0,166,135,1) 0%, rgba(29,246,206,1) 100%);
  display: flex;
  justify-content: center;
  height: 100%;
  min-height: 100vh;
  width: 100%;

  & > img {
    animation: ${bounce} 2s ease infinite;
  }
`
